<template>
  <input
    type="text"
    v-model="selectedValue"
    class="browser-default e4s-input-field e4s-input-field--primary"
    :class="isDisabled ? 'e4s-input-field--disabled' : ''"
    :disabled="isDisabled"
    :placeholder="placeholder"
    v-on:keyup="debounceOnChange"
  />
</template>

<script setup lang="ts">
import { debounce } from '../../debounce'
import { ref, watch } from 'vue'

const props = defineProps({
  value: {
    type: String,
    default: ''
  },
  defaultValue: {
    type: String,
    default: ''
  },
  defaultObjectHack: {
    type: Object,
    default: () => {
      return {
        id: '',
        description: ''
      }
    }
  },
  placeholder: {
    type: String,
    default: ''
  },
  isDisabled: {
    type: Boolean,
    default: false
  },
  debounceRate: {
    type: Number,
    default: 250
  }
})

const emit = defineEmits(['input'])

//  This does NOT make sense.
const selectedValue = ref(props.defaultValue ? props.defaultValue : props.value)

watch(
  () => props.value,
  (newValue) => {
    if (newValue !== selectedValue.value) {
      console.log('InputDebounce.watch()...newValue: ' + newValue)
      selectedValue.value = newValue
    }
  }
)

const debounceOnChange = debounce(() => {
  console.log('InputDebounce.debounceOnChange()...selectedValue: ' + selectedValue.value)
  emit('input', selectedValue.value)
}, props.debounceRate)

/*
@Component({
  name: 'input-debounce'
})
export default class InputDebounce extends Vue {
  @Prop({ default: '' })
  public readonly value!: string

  @Prop({ default: '' })
  public readonly defaultValue!: string

  @Prop({
    default: () => {
      return {
        id: '',
        description: ''
      }
    }
  })
  public readonly defaultObjectHack!: IBase

  @Prop({ default: '' })
  public readonly placeholder!: string

  @Prop({ default: false })
  public readonly isDisabled: boolean

  @Prop({ default: 250 })
  public readonly debounceRate: number

  public selectedValue = ''
  public debounceOnChange: any

  @Watch('value')
  public onValueChanged(newValue: string) {
    if (newValue !== this.selectedValue) {
      this.selectedValue = newValue
    }
  }

  @Watch('defaultValue')
  public onDefaultValueChanged(newValue: string) {
    // if (newValue.length > 0) {
    if (newValue !== this.selectedValue) {
      this.selectedValue = newValue
    }
    // }
  }

  @Watch('defaultObjectHack')
  public onDefaultObjectHackChanged(newValue: IBase, oldValue: IBase) {
    if (newValue !== oldValue) {
      this.selectedValue = ''
    }
  }

  public created(): void {
    if (this.defaultValue.length > 0) {
      if (this.defaultValue !== this.selectedValue) {
        this.selectedValue = this.defaultValue
      }
    }

    this.debounceOnChange = debounce(() => {
      console.log('InputDebounce.debounceOnChange()...selectedValue: ' + this.selectedValue)
      this.onChange()
    }, this.debounceRate)
  }

  public onChange(): void {
    this.$emit('input', this.selectedValue)
  }
}
 */
</script>
